import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import NavbarCourier from "../components/NavbarCourier";
import CourierOrderCard from "./CourierOrderCard/CourierOrderCard.tsx";
import "./CourierOrders.css";
import { Button, Modal } from "@mui/material";
import jwtDecode from "jwt-decode";
import axios from "axios";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CourierOrders = () => {
  const [value, setValue] = React.useState(0);
  const [activeOrder, setActiveOrder] = useState({});
  const [preparingFood, setPreparingFood] = useState([]);
  const [courierId, setCourierId] = useState(null);
  // const [orderId, setOrderId] = useState(null);
  const [userId, setUserId] = useState(null);
  console.log("from state: ", activeOrder);
  // const [open, setOpen] = useState(false);

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    if (token) {
      const decodedToken = jwtDecode(token);
      setCourierId(decodedToken.courierId);
      setUserId(decodedToken.UserId);
      console.log("from courier id: ", decodedToken.courierId);
    }
  }, []);

  useEffect(() => {
    const getActiveOrders = async () => {
      try {
        if (courierId) {
          const response = await axios.get(
            `${process.env.REACT_APP_SECRET}/api/Courier/GetAllActiveOrdersByCourierId?courierId=${courierId}`
          );
          console.log("from API: ", response.data);
          setActiveOrder(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getActiveOrders();
  }, [courierId]);

  useEffect(() => {
    const getAllPreparingFood = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Courier/GetAllPreparingFood`
        );
        console.log(response.data);
        setPreparingFood(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getAllPreparingFood();
  }, []);

  const getAllPreparingFoodOnClick = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/Courier/GetAllPreparingFood`
      );
      console.log(response.data);
      setPreparingFood(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getActiveOrderOnClick = async () => {
    try {
      if (courierId) {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Courier/GetAllActiveOrdersByCourierId?courierId=${courierId}`
        );
        console.log("from API: ", response.data);
        setActiveOrder(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAcceptOrder = async (orderId, statusId) => {
    try {
      // setOrderId(orderId);

      const postData = {
        orderIds: [orderId],
        courierId,
        statusId,
        creatorId: userId,
        modifierId: userId,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SECRET}/api/Courier/AddCourierOrder`,
        postData
      );
      console.log("update data: ", response.data);

      if (response.data) {
        getAllPreparingFoodOnClick();
        getActiveOrderOnClick();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelOrder = async (id) => {
    try {
      if (id) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SECRET}/api/Courier/CancelActiveOrder/${id}`
        );
        console.log("deleted: ", response.data);

        if (response.data > 0) {
          getActiveOrderOnClick();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <NavbarCourier></NavbarCourier>
      <div className="fs-2 text-center fw-bold my-3">Orders</div>
      <Box className="mx-auto tab-container">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Incoming" {...a11yProps(0)} />
            <Tab label="Active" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <div className="order-container">
            {preparingFood.length > 0 ? (
              preparingFood.map((food, index) => (
                <CourierOrderCard
                  key={index}
                  food={food}
                  index={index}
                  handleAcceptOrder={handleAcceptOrder}
                ></CourierOrderCard>
              ))
            ) : (
              <div className="fs-3 text-center mt-3 text-secondary">
                No Incoming Order
              </div>
            )}
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {activeOrder ? (
            <div className="shadow p-3">
              <div className="d-flex justify-content-between flex-wrap fw-semibold">
                <div>
                  <div className="my-2">
                    Restaurant Name: {activeOrder?.restaurantName}
                  </div>
                  <div className="my-2">
                    Restaurant Address: {activeOrder?.address}
                  </div>
                  <div className="my-2">
                    Restaurant Status: {activeOrder?.restaurantStatus}
                  </div>
                </div>

                <div>
                  <div className="my-2">
                    Delivery Address: {activeOrder?.address}
                  </div>
                  {/* <div className="my-2">Mobile Number: 111111111</div> */}
                </div>
              </div>

              <div className="QR-btn-container d-flex flex-column align-items-center">
                <div className="my-2 fw-semibold">
                  Total Earning After Delivery: {activeOrder?.deliveryFee}&#163;
                </div>
                <div className="my-2 fw-semibold">
                  Current Status: {activeOrder?.courierStatus}
                </div>
                <button className="my-2 border-0 py-2 rounded w-100">
                  Show QR Code
                </button>
                <button
                  onClick={() => handleCancelOrder(activeOrder?.id)}
                  className="my-2 border-0 py-2 rounded w-100"
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div className="fs-3 text-center mt-3 text-secondary">
              No Active Order
            </div>
          )}

          {/* <div>
            <Modal
              open={open}
              onClose={ () => setOpen(false) }
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Text in a modal
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                </Typography>
              </Box>
            </Modal>
          </div> */}
        </CustomTabPanel>
      </Box>
    </div>
  );
};

export default CourierOrders;
